import React from "react";
import { DndProvider } from "react-dnd";
import Backend from "react-dnd-html5-backend";
import Sprite from "./Sprite/BattleSprite";
import GambitTable from "./GambitTable/GambitTable";
import BattleInfo from "./BattleInfo";
import { BattleEntryProps } from "./types";

function BattleEntry(props: BattleEntryProps) {
  const { gambitProps, infoProps, frameProps } = props;
  const { index, dispatch, gambitData, editable } = gambitProps;
  const swapItems = (order: number, otherOrder: number) => {
    dispatch({ type: "swapGambits", payload: { index, order, otherOrder } });
  };
  const toggleItemActive = (id: string) => {
    dispatch({ type: "activateGambit", payload: { index, id } });
  };
  const changeItem = (id: string) => {
    dispatch({ type: "changeGambit", payload: { index, id } });
  };
  const actions = { swapItems, toggleItemActive, changeItem };
  return (
    <div className="battle-entry">
      <BattleInfo {...infoProps} />
      <Sprite {...frameProps} />
      <DndProvider backend={Backend}>
        <GambitTable {...{ gambitData, editable, actions }} />
      </DndProvider>
    </div>
  );
}

export default BattleEntry;
